/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class EndTrialNowControllerService {
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static legacyEndTrialNow({
        redirect = true,
    }: {
        redirect?: boolean,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/end-trial-now',
            query: {
                'redirect': redirect,
            },
        });
    }
    /**
     * @returns string OK
     * @throws ApiError
     */
    public static endTrialNow({
        redirect = true,
    }: {
        redirect?: boolean,
    }): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/dashboard/api/v1/billing/end-trial-now',
            query: {
                'redirect': redirect,
            },
        });
    }
}
